<template>
    <div class="relative">
        <vx-elastic-suggest
            ref="contactTagSuggest"
            show-on-focus
            :listen-for="0"
            :search_groups="source_group"
            :clearable="false"
            :select-like="false"
            @input="addTag"
            @hovered="(v) => (hovered = v)"
            @focus="focused = true"
            @blur="focused = false"
            @selectionCleared="clearList"
        >
            <template v-slot:Tag="{ suggestion }">
                <div
                    class="flex flex-no-wrap items-center leading-none"
                    :variable="(iconData = getIconInfo(suggestion))"
                >
                    <vx-basic-icon
                        :icon="iconData.icon"
                        :color="iconData.color"
                        svgClasses="h-6 w-6 "
                        class="mr-3"
                    />
                    <span>{{ getText(suggestion) }}</span>
                </div>
            </template>
        </vx-elastic-suggest>
        <div v-if="!focused" class="absolute flex" style="top: 0.75rem; left: 2.5rem; z-index: 200">
            <vs-chip
                v-for="(tag, i) in selectedTags"
                transparent
                closable
                :color="colors[i]"
                close-icon="close"
                class="employee-chip mr-3"
                :key="getId(tag)"
                @click="removeTag(tag)"
            >
                {{ getText(tag) }}
            </vs-chip>
        </div>
    </div>
</template>

<script>
import VxElasticSuggest from '../../components/generic/VxElasticSuggest.vue'
import _color from '@/assets/utils/color.js'

export default {
    components: { VxElasticSuggest },
    name: 'vx-tag-box',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        availableTags: {
            type: Array,
            default: () => []
        },
        idKey: {
            type: String,
            default: 'id'
        },
        nameKey: {
            type: [String, Function],
            default: 'displayText'
        }
    },
    data() {
        return {
            hovered: null,
            focused: false
        }
    },
    computed: {
        colors() {
            return _color.getPentadicSet('primary').shuffle()
        },
        selectedTags: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        },
        getId() {
            return (tag) => tag[this.idKey]
        },
        getText() {
            if (typeof this.nameKey === 'function') {
                return this.nameKey
            }
            return (tag) => tag[this.nameKey]
        },
        source_group() {
            return {
                Tag: {
                    idfield: this.idKey,
                    searchOn: this.getText,
                    data: this.availableTags
                }
            }
        }
    },
    methods: {
        clearList() {
            this.$emit('tagsCleared')
            this.selectedTags = []
        },
        checkIsSelected(tag) {
            return this.value.contains(tag)
        },
        getIconInfo(tag) {
            if (!this.checkIsSelected(tag)) {
                return {
                    icon: 'SquareIcon'
                }
            }

            if (this.hovered == tag) {
                return {
                    icon: 'XIcon',
                    color: 'danger',
                    rounded: true
                }
            }
            return {
                icon: 'CheckSquareIcon',
                color: 'success'
            }
        },
        removeTag(tagObject) {
            this.$emit('tag-removed', tagObject)
        },
        addTag(tagObject) {
            if (this.value.contains(tagObject)) {
                this.removeTag(tagObject)
                return
            }
            this.$emit('tag-added', tagObject)
        }
    }
}
</script>
<style lang="scss" scoped>
.employee-chip {
    margin: -4.5px 5px;
    transform: scale(1.1);
    color: rgba(var(--vs-dark), 1);
    user-select: none;
    font-size: 1rem;
    transition: all 0.2s ease;
    white-space: nowrap;
}
.employee-chip ::v-deep button {
    background: rgba(var(--vs-danger), 0.2);
}
.employee-chip:hover {
    background: rgba(var(--vs-danger), 0.15);
}
.employee-chip ::v-deep button:hover {
    background: rgba(var(--vs-danger), 0.8);
    transform: scale(1.05);
}
</style>
